import AxiosInatance from "axios";
import config from "./config";
import history from './history';
import CryptoJS from 'crypto-js';
import { localStorageLogoutConditions } from "../utils/services";
import {showToast} from "./functions";

const multipartFormDataRoutes =
  ["/inventory/saveInventoryWithExcel",
    "/areaMapping/updateMasterId",
    "/ASN/bulkASNItemUpload",
    "/sales/bulkSalesOrderItemUpload",
    "/ASN/saveMultiASN",
    "/sales/saveMultiSalesOrder",
    "inventory/multiASNReceiving",
    "/inventory/bulkUploadRawStock",
    "/inventory/bulkSerricoTrapToGridMapping",
    "/inventory/bulkReplaceSerricoTrap",
    "sales/createDispatchPlan",
    "job/verifyDispatchPlan",
    "job/excelJobCompletion",
    "job/verifyPreShipmentInpection",
    "/inventoryAdjustment/adjustmentExcelUpload",
    "inventory/uploadSKUImages",
    "ASN/verifyStockTransferReceiving",
    "inventory/saveUIDForQtyWiseLabel",
  ];

export const encryptData = (data) => {
  const secretKey = '12345678901234567890123456789012';
  const key = CryptoJS.enc.Utf8.parse(secretKey);

  // Generate a random IV
  const iv = CryptoJS.lib.WordArray.random(16);

  // Encrypt the data
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    iv: iv
  });

  // Prepend the IV to the encrypted data
  return iv.toString() + encrypted.toString();
};


// The below function we are using to encrypt the payload data in forgot and change password and login
export const encryptTheData = (data) =>{  
  let _key = CryptoJS.enc.Utf8.parse("pAUGvR0awF5ot2N5");
  let _iv = CryptoJS.enc.Utf8.parse("pAUGvR0awF5ot2N5");
  let encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), _key,
      {
          keySize: 16,
          iv: _iv,
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
      });
  return encrypted.toString();
}

const axios = AxiosInatance.create({
  baseURL: config.baseURL || "/v1/",
  headers: {
    "Content-Type": "application/json",
    // "Authorization": JSON.parse(localStorage.getItem("token"))
  }
});

var token2 = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6eyJjcmVhdGVkRGF0ZSI6IjIwMjMtMDYtMTZUMDU6NTM6NDUuNjU1Wi02NDM3OWM2NmMzNDJmMDA0ZGQwZmEyOGQiLCJwZXJtaXNzaW9ucyI6eyJpbmRvb3JUcmFja2luZyI6dHJ1ZX0sIl9pZCI6IjY0Mzc5YzY2YzM0MmYwMDRkZDBmYTI4ZCIsInVzZXJUeXBlIjoiYWRtaW4iLCJuYW1lIjoiRXhwZXJpZW5jZSBDZW50ZXIiLCJlbWFpbCI6ImV4cGVyaWVuY2VAbHlua2l0LmluIiwiaXNPbkR1dHkiOmZhbHNlLCJhcHByb3ZlZCI6dHJ1ZSwiY29tcGFueSI6IkV4cGVyaWVuY2UgQ2VudGVyIiwiYmFzZSI6IjEzNjQyN2M3LTJjYWMtNDUxNS04MWFkLWI4YWJkNDZiZGYzNy0xNjgxMzY1OTkxNzc4IiwiZGVzaWduYXRpb24iOiJFeHBlcmllbmNlIn0sImlhdCI6MTY4Njg5NDgyNSwiZXhwIjo2LjMxMTM5MDQ4ODg4ODkwNmUrMjN9.kNejXKM2eYzdE8o-nyfsR32opgBBQxDW0SQQyUnUBbs"

// ---- Smart Toast Controller (Deduplicated + Cooldown) ----
const toastCooldownMap = {
  NETWORK: false,
  SERVER: false,
};

const TOAST_COOLDOWN_TIME = 3000; // 3 seconds

function showSmartToast(type, message, isError = true) {
  if (toastCooldownMap[type]) {
    return; //  Already showing / recently shown
  }

  toastCooldownMap[type] = true;

  showToast(message, isError);

  setTimeout(() => {
    toastCooldownMap[type] = false; //  Allow again after cooldown
  }, TOAST_COOLDOWN_TIME);
}


axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  // console.log("config>>>>>>",config)

  let project=localStorage.getItem("project")
  if(project){
    config.headers["project"] = project
  }

  if (multipartFormDataRoutes.includes(config.url)) {
    config["headers"]["Content-Type"] = 'multipart/form-data'
  }
  if (config.url.includes("getAllUserData")) {
    config["headers"]["Authorization"] = token2
  }
  else  if (["ESO/getESOFormConfigDetail","ESO/submitESOResponse"].includes(config.url) && window.localStorage.getItem("passToken") && config["headers"]) {
    config["headers"]["partialaccesstoken"] = JSON.parse(window.localStorage.getItem("passToken"))
  }
  else if (window.localStorage.getItem("token") && config["headers"]) {
    // if (config.data) {
    //   config = {
    //     ...config,
    //     "data": {"encryptedData":encryptData(config.data)}
    //   };
    //   console.log(config,"uuu",encryptData(config.data))
    // }
    config["headers"]["Authorization"] = JSON.parse(window.localStorage.getItem("token"))
  }
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {

  // Do something with response data
  let { config: { url }, data: { inValidToken = false, message } } = response

  
  // //("response>>>", {inValidToken,url});
  if (url && !url.includes("getAllUserData") && inValidToken) {//response.status == 201 &&
    // window.localStorage.clear();
    localStorageLogoutConditions()
    window.localStorage.setItem("TokenExpirymesssage", message || "Session expired, please logout and login again!");

    history.push("/login")
    // window.location.href = '/';
  }

  return response

}, function (error) {
  // Do something with response error
  console.log("error.response>>>", error);
  // window.localStorage.clear();
  // window.localStorage.setItem("TokenExpirymesssage", error.message || "Some error ocuured!");
  // history.push("/login")
  // history.push("/error?type==internal-server-error")
  const status = error?.response?.status;

  // ✅ Gateway / server down errors
//   if (status === 502 || status === 504 || status === 503) {
//     showSmartToast(
//       "SERVER",
//       "Server is temporarily unavailable. Please try again in a few minutes.",
//       true
//     );
//   }
//   // ✅ Network error (no internet / server unreachable)
//   else 
  if (!error?.response) {
    showSmartToast(
      "NETWORK",
      "Network error. Please check your internet connection.",
      true
    );
  }
  // ✅ Optional: generic fallback
  else if (status >= 500) {
    showSmartToast(
        "SERVER",
        "Something went wrong. Please try again later.",
        true
    );
  }
  return Promise.reject(error);
});


export default axios;



